import { Gruppe } from '../../../gruppen/classes/gruppe';
import { Betriebskontakt } from '../../../stammdaten/betriebskontakte/betriebskontakt';
import { Haendler } from '../../../stammdaten/haendler/haendler';

export interface GruppeTierScanImportierenDialogPrefill {
    kpEinstalldatum?: Date | null;
    bemerkung?: string | null;
    abteil?: string | null;
    viehhaendler?: Haendler | null;
    betriebskontakt?: Betriebskontakt | null;
}

export interface GruppeTierScanImportierenDialogData {
    gruppe: Gruppe;
    prefill?: GruppeTierScanImportierenDialogPrefill;
    einstall_tierliste_id?: number | null;
}

export function resolveGruppeTierScanImportierenDialogData(
    data: Gruppe | GruppeTierScanImportierenDialogData,
): GruppeTierScanImportierenDialogData {
    if (data && typeof data === 'object' && 'gruppe' in data) {
        return data as GruppeTierScanImportierenDialogData;
    }
    return { gruppe: data as Gruppe };
}
